// Explicit, per-element-type SVG attribute whitelists.
// Used to avoid unsafe prop spreading onto DOM/SVG elements.

const STYLE_ATTRS = [
  "fill",
  "stroke",
  "strokeWidth",
  "opacity",
  "fillOpacity",
  "strokeOpacity",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "transform",
  // "arrow" is a boolean flag (not a real SVG attr) that tells the renderer
  // to attach an arrowhead marker. It is preserved through line-edit round-trips
  // and export serialization, but stripped from the actual SVG element props.
  "arrow",
  // "arrowStart" / "arrowEnd" select the decoration type for each endpoint of
  // an arrow (none, round, square, line-arrow, ...). Like "arrow", they are
  // meta-attrs: preserved for line-edit/export but not spread onto the DOM.
  "arrowStart",
  "arrowEnd",
];

export const ELEMENT_ATTRS = {
  rect: ["x", "y", "width", "height", "rx", "ry", ...STYLE_ATTRS],
  circle: ["cx", "cy", "r", ...STYLE_ATTRS],
  ellipse: ["cx", "cy", "rx", "ry", ...STYLE_ATTRS],
  line: ["x1", "y1", "x2", "y2", ...STYLE_ATTRS],
  polygon: ["points", ...STYLE_ATTRS],
  polyline: ["points", ...STYLE_ATTRS],
  path: ["d", "pathLength", ...STYLE_ATTRS],
  text: [
    "x",
    "y",
    "fontSize",
    "fontFamily",
    "fontWeight",
    "fontStyle",
    "textAnchor",
    "letterSpacing",
    "textDecoration",
    ...STYLE_ATTRS,
  ],
  image: [
    "x",
    "y",
    "width",
    "height",
    "href",
    "preserveAspectRatio",
    "opacity",
    "transform",
  ],
};

// Build a clean props object for an SVG element, keeping only valid
// attributes for its type. Empty strings and nullish values are dropped.
export function svgPropsFor(type, attrs = {}) {
  const allowed = ELEMENT_ATTRS[type] || [];
  const out = {};
  for (const key of allowed) {
    const value = attrs[key];
    if (value !== undefined && value !== null && value !== "") {
      // "arrow", "arrowStart", "arrowEnd" are meta-flags, not real SVG
      // attributes — don't spread them onto the DOM node. The renderer reads
      // them separately to build the path decorations.
      if (key === "arrow" || key === "arrowStart" || key === "arrowEnd") continue;
      out[key] = value;
    }
  }
  return out;
}
